export default "__VITE_ASSET__Dv1vbMY6__"